export enum HaggleEventFormOptions {
	VIEW = 'VIEW',
	CREATE = 'CREATE',
	UPDATE = 'UPDATE',
}
